import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "it",
  setLang: () => {},
  t: translations.it,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "it";
    return window.localStorage.getItem("adr_lang") || "it";
  });

  const setLang = (l) => {
    setLangState(l);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("adr_lang", l);
    }
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: translations[lang] || translations.it,
  };

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
